export function amendBeneficiaryDetailsRequest(lang) {
    const php=`
        $url = 'https://sandbox.sasapay.app/api/v1/waas/beneficiary/update/';
        $data = [
            "MerchantCode": "*****",
            "FirstName": "*********",
            "MiddleName": "",
            "LastName": "******",
            "DocumentType": *,
            "DocumentNumber": "*****",
            "Email": "*******",
            "BeneficiaryAccountNumber": "*********"
        ];
         $header=[
                'Content-Type:application/json',
                'Authorization:Bearer {{TOKEN}}'
         ];
    
        $ch = curl_init($url);
        curl_setopt($curl, CURLOPT_HTTPHEADER, $header);
        curl_setopt($ch, CURLOPT_POST, 1);
        curl_setopt($ch, CURLOPT_POSTFIELDS, http_build_query($data));
        curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
        
        $response = curl_exec($ch);
        curl_close($ch);
        
        echo $response;
    `
    const java=`
        OkHttpClient client = new OkHttpClient().newBuilder()
          .build();
        MediaType mediaType = MediaType.parse("application/json");
        RequestBody body = RequestBody.create(mediaType, "{\\n    \\"MerchantCode\\": \\"*****\\",\\n    \\"FirstName\\": \\"*******\\",\\n    \\"MiddleName\\": \\"\\",\\n    \\"LastName\\": \\"********\\",\\n    \\"DocumentType\\": *,\\n    \\"DocumentNumber\\": \\"****\\",\\n    \\"Email\\": \\"*****\\",\\n    \\"BeneficiaryAccountNumber\\": \\"********\\"\\n}");
        Request request = new Request.Builder()
          .url("https://sandbox.sasapay.app/api/v1/waas/beneficiary/update/")
          .method("POST", body)
          .addHeader("Authorization", "Bearer 6QsqIDlrpD1ZwZFBd8DjGGQzyYOejk")
          .addHeader("Content-Type", "application/json")
          .build();
        Response response = client.newCall(request).execute();
    `
    const python=`
        import requests
        import json
        
        url = "https://sandbox.sasapay.app/api/v1/waas/beneficiary/update/"
        
        payload = json.dumps({
          "MerchantCode": "****",
          "FirstName": "***",
          "MiddleName": "",
          "LastName": "***",
          "DocumentType": *,
          "DocumentNumber": "***",
          "Email": "***",
          "BeneficiaryAccountNumber": "****"
        })
        headers = {
          'Authorization': 'Bearer 6QsqIDlrpD1ZwZFBd8DjGGQzyYOejk',
          'Content-Type': 'application/json'
        }
        
        response = requests.request("POST", url, headers=headers, data=payload)
        
        print(response.text)

    `
    const nodejs=`
        const unirest = require('unirest');
        const req = unirest('POST', 'https://sandbox.sasapay.app/api/v1/waas/beneficiary/update/')
          .headers({
            'Authorization': 'Bearer 6QsqIDlrpD1ZwZFBd8DjGGQzyYOejk',
            'Content-Type': 'application/json'
          })
          .send(JSON.stringify({
            "MerchantCode": "******",
            "FirstName": "*******",
            "MiddleName": "",
            "LastName": "********",
            "DocumentType": *,
            "DocumentNumber": "******",
            "Email": "********",
            "BeneficiaryAccountNumber": "*********"
          }))
          .end(function (res) { 
            if (res.error) throw new Error(res.error); 
            console.log(res.raw_body);
          });
    `
    switch (lang) {
        case 'php':
            return php;
        case 'javascript':
            return nodejs;
        case 'java':
            return java;
        case 'python':
            return python;
        default:
            return `Coming Soon!`;
    }
}
export function amendBeneficiaryDetailsCodeResponse() {
    return `   
    {
        "statusCode": 0,
        "message": "Success.Kindly await verification."
    }
    `
}
export function topUpBeneficiaryRequest(lang) {
    const php=`
        $url = 'https://sandbox.sasapay.app/api/v1/waas/customers/load-wallet/request/';
        $data = [
            "TransactionReference":"********",
            "NetworkCode": "**",
            "MobileNumber": "******",
            "BeneficiaryAccountNumber": "******",
            "Amount": "**",
            "TransactionFee":0,
            "CurrencyCode":"KES",
            "MerchantCode": "831398",
            "CallBackUrl":"https://posthere.io/4bdd-47d5-a54d/callback/",
            "Reason": "Customer Reason"
}',
        ];
         $header=[
                'Content-Type:application/json',
                'Authorization:Bearer {{TOKEN}}'
         ];
    
        $ch = curl_init($url);
        curl_setopt($curl, CURLOPT_HTTPHEADER, $header);
        curl_setopt($ch, CURLOPT_POST, 1);
        curl_setopt($ch, CURLOPT_POSTFIELDS, http_build_query($data));
        curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
        
        $response = curl_exec($ch);
        curl_close($ch);
        
        echo $response;
    `
    const java=`
        OkHttpClient client = new OkHttpClient().newBuilder()
          .build();
        MediaType mediaType = MediaType.parse("application/json");
        RequestBody body = RequestBody.create(mediaType, "{\\n    \\"MerchantCode\\": \\"*****\\",\\n    \\"FirstName\\": \\"*******\\",\\n    \\"MiddleName\\": \\"\\",\\n    \\"LastName\\": \\"********\\",\\n    \\"DocumentType\\": *,\\n    \\"DocumentNumber\\": \\"****\\",\\n    \\"Email\\": \\"*****\\",\\n    \\"BeneficiaryAccountNumber\\": \\"********\\"\\n}");
        Request request = new Request.Builder()
          .url("https://sandbox.sasapay.app/api/v1/waas/beneficiary/update/")
          .method("POST", body)
          .addHeader("Authorization", "Bearer 6QsqIDlrpD1ZwZFBd8DjGGQzyYOejk")
          .addHeader("Content-Type", "application/json")
          .build();
        Response response = client.newCall(request).execute();
    `
    const python=`
    import requests
    import json
    
    url = "https://sandbox.sasapay.app/api/v1/waas/customers/load-wallet/request/"
    
    payload = json.dumps({
      "TransactionReference": "34218101",
      "NetworkCode": "0",
      "MobileNumber": "0702440280",
      "BeneficiaryAccountNumber": "831398-3",
      "Amount": 10,
      "TransactionFee": 0,
      "CurrencyCode": "KES",
      "MerchantCode": "831398",
      "CallBackUrl": "https://posthere.io/4bdd-47d5-a54d/callback/",
      "Reason": "Customer Reason"
    })
    headers = {
      'Authorization': 'Bearer 6QsqIDlrpD1ZwZFBd8DjGGQzyYOejk',
      'Content-Type': 'application/json'
    }
    
    response = requests.request("POST", url, headers=headers, data=payload)
    
    print(response.text)

    `
    const nodejs=`
        const unirest = require('unirest');
        const req = unirest('POST', 'https://sandbox.sasapay.app/api/v1/waas/beneficiary/update/')
          .headers({
            'Authorization': 'Bearer 6QsqIDlrpD1ZwZFBd8DjGGQzyYOejk',
            'Content-Type': 'application/json'
          })
          .send(JSON.stringify({
            "MerchantCode": "******",
            "FirstName": "*******",
            "MiddleName": "",
            "LastName": "********",
            "DocumentType": *,
            "DocumentNumber": "******",
            "Email": "********",
            "BeneficiaryAccountNumber": "*********"
          }))
          .end(function (res) { 
            if (res.error) throw new Error(res.error); 
            console.log(res.raw_body);
          });
    `
    switch (lang) {
        case 'php':
            return php;
        case 'javascript':
            return nodejs;
        case 'java':
            return java;
        case 'python':
            return python;
        default:
            return `Coming Soon!`;
    }
}
export function topUpBeneficiaryResponse() {
    return `   
    {
        "statusCode": 0,
        "message": "Success.Kindly await verification."
    }
    `
}